export default "__VITE_ASSET__aqb6U6Z8__"